import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "ant-input-wrapper ant-input-group ui-ta-right"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "ant-input-group-addon" }, "CM", -1)
const _hoisted_3 = {
  key: 1,
  class: "ant-input-wrapper ant-input-group ui-ta-right"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "ant-input-group-addon" }, "KG", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_money3 = _resolveComponent("money3")!

  return (_ctx.props.centimetro)
    ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
        _createVNode(_component_money3, _mergeProps({
          class: "ant-input",
          modelValue: _ctx.computedValor,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.computedValor) = $event)),
          modelModifiers: { number: true }
        }, _ctx.obterConfiguracao(0)), null, 16, ["modelValue"]),
        _hoisted_2
      ]))
    : (_ctx.props.peso)
      ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
          _createVNode(_component_money3, _mergeProps({
            class: "ant-input",
            modelValue: _ctx.computedValor,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.computedValor) = $event)),
            modelModifiers: { number: true }
          }, _ctx.obterConfiguracao(3)), null, 16, ["modelValue"]),
          _hoisted_4
        ]))
      : _createCommentVNode("", true)
}